export enum DEFAULT_ASSETS {
    // displays form when user tries to load page
    LANDING_SCREEN_VIDEO_URL = 'https://s3.ap-southeast-2.amazonaws.com/assets.webar.viewa.com/clients/warwick/warwick-video-v3-compressed.mp4',
}
